import { render, staticRenderFns } from "./MarketingRegistration.vue?vue&type=template&id=c81e39ee&"
import script from "./MarketingRegistration.vue?vue&type=script&lang=ts&"
export * from "./MarketingRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports